import {Link} from 'react-router-dom';
import {ArrowRight,Flame} from 'lucide-react';
import {useLanguage} from '../i18n/LanguageProvider';
import '../styles/team-banner.css';
/** Team banner. The photo was rebuilt in ChatGPT from the original staff photo (data/source/gpt-images/team-original) —
 *  the empty left 30% of the frame is the text zone; the people occupy the right 70%. Text is a solid HUD panel, never over faces. */
export function TeamBanner(){
 const {t}=useLanguage();
 return <section className="container tb" aria-labelledby="tb-title">
  <div className="tb-frame">
   <picture><source media="(max-width:1000px)" srcSet="/assets/company/team-banner-mobile.webp"/><img className="tb-img" src="/assets/company/team-banner.webp" alt={t('Đội ngũ NIBELC')} loading="lazy" decoding="async" width="1916" height="821"/></picture>
   <i className="fo-reticle tl tb-r"/><i className="fo-reticle tr tb-r"/>
   <div className="tb-text">
    <span className="tb-flag"><Flame size={14} aria-hidden="true"/><b>TEAM</b><i aria-hidden="true"/>{t('ĐỘI NGŨ')}</span>
    <h2 id="tb-title">{t('ĐỘI NGŨ NIBELC')}</h2>
    <p>{t('Những con người đứng sau hành trình kết nối nhân lực, đào tạo và hợp tác quốc tế của NIBELC.')}</p>
    <span className="tb-note">{t('Ảnh tư liệu NIBELC, được dựng lại từ ảnh gốc.')}</span>
    <Link to="/lien-he" className="tb-cta">{t('KẾT NỐI VỚI CHÚNG TÔI')}<ArrowRight size={18} aria-hidden="true"/></Link>
   </div>
  </div>
 </section>;
}
